export default __webpack_public_path__ + "static/media/Web-logo.7309c343.png";